import { useState } from 'react';

import { BankSelectionModal } from './BankSelectionModal';
import { useGetLinkedAccounts } from './useGetLinkedAccounts';
import {
    clearTrueLayerParams,
    isTrueLayerSuccessReturn
} from '../../../iwRouter/LocationHelper';

export const OpenBankingSuccessRedirect = () => {
    const [isOpen, setIsOpen] = useState(true);
    const linkedAccounts = useGetLinkedAccounts();

    if (!isTrueLayerSuccessReturn()) {
        return null;
    }

    return (
        <BankSelectionModal
            isOpen={isOpen}
            initialStep="success"
            linkedAccounts={linkedAccounts}
            onClose={() => {
                clearTrueLayerParams();
                setIsOpen(false);
            }}
        />
    );
};
